/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.image_utils
 */
function cloudinaryImage() {

    return {
        restrict: 'E',
        link: link,
        scope: {
             imageId: '<',
             imageUrl: '<',
             imageAlt: '<',
             imageCloudinary: '<'
        },
        controller: cloudinaryImageCtrl,
        template: require('./cloudinaryImageView.html'),
    };
}

cloudinaryImageCtrl.$inject = ['$scope', '$timeout'];
function cloudinaryImageCtrl($scope, $timeout) {
    if ($scope.imageCloudinary === undefined) {
        $scope.imageCloudinary = $scope.imageUrl;
    }

    $scope.imageLoadFailed = false;
    $scope.checkLogoLoaded = function () {
        // check that cloudinary images loaded
        $timeout( function () {
            var retailerLogo = document.getElementById($scope.imageId);
            if (!retailerLogo) {
                $scope.imageLoadFailed = true;
            }
        });
    };
}

/**
 * If the cloudinary image did not load.
 *
 * @param scope
 * @param element
 * @param attrs
 */
function link (scope, element, attrs) {
    element.ready(function () {
        scope.checkLogoLoaded();
    });
}

module.exports = cloudinaryImage;
